import React, { useState, createContext, useContext } from 'react';
type Language = 'es' | 'en';
interface I18nContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string) => string;
}
const I18nContext = createContext<I18nContextType | undefined>(undefined);
// Simple dictionary implementation
import { dictionary } from './content';
export function I18nProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Language>('es');
  const t = (key: string): string => {
    const keys = key.split('.');
    let current: any = dictionary[lang];
    for (const k of keys) {
      if (current[k] === undefined) {
        console.warn(`Translation key not found: ${key}`);
        return key;
      }
      current = current[k];
    }
    return current as string;
  };
  return <I18nContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-244">
      {children}
    </I18nContext.Provider>;
}
export function useI18n() {
  const context = useContext(I18nContext);
  if (context === undefined) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
}